import { RESERVE_LEVEL_SELECT_CHANGE_SELECTED_LEVEL } from '../actions/reserve_level_select'

const initialState = {
    selectedLevel: 1,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case RESERVE_LEVEL_SELECT_CHANGE_SELECTED_LEVEL:
        return {
            ...state,
            selectedLevel: action.payload.selectedLevel,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/reserve_level_select.js